    document.addEventListener('DOMContentLoaded', function() {
      var successMessage = document.getElementById('successMessage');
  
      if (successMessage) {
        setTimeout(function() {
          successMessage.setAttribute('tabindex', '-1');
          successMessage.focus();
  
        }, 100); // Adding a slight delay to ensure the DOM is fully loaded and focus works correctly
      }
    });